import React, { useState } from "react";

interface ChangelogItem {
  icon: string;
  text: string;
}

const iconMap: Record<string, string> = {
  "/imgs/profile.svg": "/imgs/profileDark.svg",
  "/imgs/chart.svg": "/imgs/chartDark.svg",
  "/imgs/ethereum.svg": "/imgs/ethereumDark.svg",
  "/imgs/passport.svg": "/imgs/passportDark.svg",
  "/imgs/paw.svg": "/imgs/darkpaw.svg",
  "/imgs/rank.svg": "/imgs/rankDark.svg",
  "/imgs/gas.svg": "/imgs/gasDark.svg",
  "/imgs/hibernated.svg": "/imgs/hibernatedDark.svg",
  "/imgs/passBadge.png": "/imgs/passBadgeDark.png",
  "/imgs/gear.svg": "/imgs/gearDark.svg",
  "/imgs/frog.svg": "/imgs/frogDark.svg",
  "/imgs/compass.svg": "/imgs/compassDark.svg",
  "/imgs/star.svg": "/imgs/starDark.svg",
  "/imgs/bolt.svg": "/imgs/boltDark.svg",
  "/imgs/coin-bag.svg": "/imgs/coin-bagDark.svg",
  "/imgs/clipboard.svg": "/imgs/clipboardDark.svg",
  "/imgs/settings.svg": "/imgs/settingsDark.svg",
  "/imgs/store.svg": "/imgs/storeDark.svg",
  "/imgs/toolbox.svg": "/imgs/toolboxDark.svg",
  "/imgs/download.svg": "/imgs/downloadDark.svg",
};

const changelogEntries: { date: string; year: number; entries: ChangelogItem[] }[] = [
  {
    date: "Oct - 13",
    year: 2025,
    entries: [
      { icon: "/imgs/download.svg", text: "add download page" },
      { icon: "/imgs/settings.svg", text: "add pet view settings toggle" },
    ],
  },
  {
    date: "Oct - 08",
    year: 2025,
    entries: [
      { icon: "/imgs/settings.svg", text: "add ens wallet search support" },
      { icon: "/imgs/settings.svg", text: "fix profile pet svg load" },
    ],
  },
  {
    date: "Oct - 05",
    year: 2025,
    entries: [
      { icon: "/imgs/settings.svg", text: "significant reduction in latency" },
      { icon: "/imgs/settings.svg", text: "improved connection speed" },
      { icon: "/imgs/toolbox.svg", text: "add fren pet social links" },
      { icon: "/imgs/passport.svg", text: "move pet passes to toggle in main viewer" },
    ],
  },
  {
    date: "Sep - 17",
    year: 2025,
    entries: [
      { icon: "/imgs/settings.svg", text: "fix dark mode issues" },
      { icon: "/imgs/settings.svg", text: "deprecate blast api" },
      { icon: "/imgs/rank.svg", text: "add loading graphic to leaderboards" },
    ],
  },
  {
    date: "Sep - 3",
    year: 2025,
    entries: [
      { icon: "/imgs/settings.svg", text: "remove activity feed" },
      { icon: "/imgs/settings.svg", text: "remove automatic data fetch" },
      { icon: "/imgs/settings.svg", text: "remove daily percentages" },
    ],
  },
  {
    date: "Aug - 13",
    year: 2025,
    entries: [
      { icon: "/imgs/toolbox.svg", text: "add resources page with fren pet links" },
      { icon: "/imgs/store.svg", text: "renew opensea API" },
    ],
  },
  {
    date: "Jul - 25",
    year: 2025,
    entries: [
      { icon: "/imgs/store.svg", text: "add homepage explore options and mint link" },
      { icon: "/imgs/settings.svg", text: "fix miscellaneous bugs" },
    ],
  },
  {
    date: "Apr - 13",
    year: 2025,
    entries: [
      { icon: "/imgs/settings.svg", text: "add dark mode setting" },
      { icon: "/imgs/chart.svg", text: "unlock pgoldbalance monthly" },
    ],
  },
  {
    date: "Feb - 10",
    year: 2025,
    entries: [
      { icon: "/imgs/profile.svg", text: "add daily point % gain to stat card" },
      { icon: "/imgs/chart.svg", text: "add daily % gain to rewards/score in profile" },
    ],
  },
  {
    date: "Jan - 19",
    year: 2025,
    entries: [
      { icon: "/imgs/profile.svg", text: "add profile viewer" },
      { icon: "/imgs/chart.svg", text: "unlock monthly view for treasury chart" },
      { icon: "/imgs/ethereum.svg", text: "add prices in header to relevant views" },
    ],
  },
  {
    date: "Dec - 19",
    year: 2024,
    entries: [
      { icon: "/imgs/ethereum.svg", text: "add ETH gas price in stat bar" },
      { icon: "/imgs/chart.svg", text: "unlock weekly view for treasury chart" },
    ],
  },
  {
    date: "Nov - 29",
    year: 2024,
    entries: [{ icon: "/imgs/passport.svg", text: "stats in pet passes view pet images" }],
  },
  {
    date: "Nov - 27",
    year: 2024,
    entries: [
      { icon: "/imgs/paw.svg", text: "blend hack for pepe contract svgs" },
      { icon: "/imgs/paw.svg", text: "normalize enlarged contract svgs" },
      { icon: "/imgs/chart.svg", text: "chart axis fixes" },
      { icon: "/imgs/passport.svg", text: "pet passes view" },
    ],
  },
  {
    date: "Nov - 26",
    year: 2024,
    entries: [
      { icon: "/imgs/chart.svg", text: "treasury chart" },
      { icon: "/imgs/chart.svg", text: "fix certain chart tooltips" },
      { icon: "/imgs/chart.svg", text: "unlock weekly view for pgold balance chart" },
      { icon: "/imgs/rank.svg", text: "add species count to leaderboards" },
      { icon: "/imgs/rank.svg", text: "fix leaderboards intraweek sort" },
    ],
  },
  {
    date: "Nov - 22",
    year: 2024,
    entries: [{ icon: "/imgs/gas.svg", text: "USD value per transaction" }],
  },
  {
    date: "Nov - 19",
    year: 2024,
    entries: [
      { icon: "/imgs/chart.svg", text: "pgold balance in charts" },
      { icon: "/imgs/hibernated.svg", text: "hibernated badge" },
      { icon: "/imgs/passBadge.png", text: "moved non-player related charts to stats" },
      { icon: "/imgs/rank.svg", text: "leaderboards refresh daily, update weekly" },
      { icon: "/imgs/passBadge.png", text: "change pets alive data to update weekly" },
    ],
  },
  {
    date: "Nov - 15",
    year: 2024,
    entries: [
      { icon: "/imgs/paw.svg", text: "top 100 leaderboards for every species" },
      { icon: "/imgs/gear.svg", text: "removed attack and defense leaderboards" },
      { icon: "/imgs/frog.svg", text: "staked FP behind eth in shop/leaderboards" },
      { icon: "/imgs/compass.svg", text: "pet EP in shop/leaderboards" },
    ],
  },
  {
    date: "Nov - 12",
    year: 2024,
    entries: [
      { icon: "/imgs/star.svg", text: "top 100 keeper leaderboard added" },
      { icon: "/imgs/compass.svg", text: "available quests badge" },
    ],
  },
  {
    date: "Nov - 11",
    year: 2024,
    entries: [
      { icon: "/imgs/bolt.svg", text: "click bolt to see remaining bonk count" },
      { icon: "/imgs/passBadge.png", text: "pass badge indicating pet has FP Pass" },
      { icon: "/imgs/frog.svg", text: "frog badge indicating staking perks active" },
      { icon: "/imgs/coin-bag.svg", text: "pGold chart updated with monthly view" },
      { icon: "/imgs/ethereum.svg", text: "click ETH symbol on pet stat card to see FP" },
      { icon: "/imgs/compass.svg", text: "pet EP updated daily" },
      { icon: "/imgs/gear.svg", text: "sort by monsters, pass holder, EP added" },
      { icon: "/imgs/passBadge.png", text: "stats view added with pet species chart" },
      { icon: "/imgs/clipboard.svg", text: "change log view added" },
    ],
  },
];

type ChangelogProps = {
  isDarkMode: boolean;
};

export const Changelog: React.FC<ChangelogProps> = ({ isDarkMode }) => {
  const [show2024, setShow2024] = useState(false);

  return (
    <div
      className={`justify-left flex h-full w-full flex-col items-center ${isDarkMode ? "bg-darkblack text-white" : "text-brown"}`}
    >
      {changelogEntries
        .filter((entry) => entry.year === 2025)
        .map((entry, index) => (
          <ChangelogEntry
            isDarkMode={isDarkMode}
            key={index}
            date={entry.date}
            entries={entry.entries}
          />
        ))}

      <div
        className={`btn-activeDarkBlue mb-1 mt-3 rounded-md border-2 p-2 [box-shadow:inset_0_-2px_#342e2e] ${isDarkMode ? "bg-dark border-darkgreen hover:bg-darkblue" : "border-brown bg-white"}`}
        onClick={() => setShow2024(!show2024)}
      >
        {show2024 ? "2024" : "2024"}
      </div>

      {show2024 &&
        changelogEntries
          .filter((entry) => entry.year === 2024)
          .map((entry, index) => (
            <ChangelogEntry
              isDarkMode={isDarkMode}
              key={index}
              date={entry.date}
              entries={entry.entries}
            />
          ))}
    </div>
  );
};

interface ChangelogEntryProps {
  date: string;
  entries: ChangelogItem[];
  isDarkMode: boolean;
}

const ChangelogEntry: React.FC<ChangelogEntryProps> = ({ isDarkMode, date, entries }) => (
  <div
    className={`mb-3 mt-2 flex flex-col items-start justify-start rounded-lg border-2 ${isDarkMode ? "border-darkgreen bg-darkblue" : "border-brown bg-white"} w-[21.5rem] [box-shadow:inset_0_-2px_#342e2e]`}
  >
    <div className="flex w-full flex-col items-start justify-center">
      <h2 className="mb-1 mt-1 p-1 text-lg font-semibold">{date}</h2>
      <hr className={`w-full border-t-2 ${isDarkMode ? "border-darkgreen" : "border-brown"}`} />
      <ul className="w-full p-2 text-sm">
        {entries.map((item, i) => (
          <li key={i} className="mb-2 flex items-center">
            <img
              src={isDarkMode && iconMap[item.icon] ? iconMap[item.icon] : item.icon}
              alt=""
              className="h-4 w-4"
            />

            <div className="ml-[.2rem] mr-1">•</div>
            <p>{item.text}</p>
          </li>
        ))}
      </ul>
    </div>
  </div>
);
